import { render, staticRenderFns } from "./UploadAvatarImage.vue?vue&type=template&id=63d9297c&scoped=true&"
import script from "./UploadAvatarImage.vue?vue&type=script&lang=js&"
export * from "./UploadAvatarImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadAvatarImage.vue?vue&type=style&index=0&id=63d9297c&lang=scss&scoped=true&"
import style1 from "./UploadAvatarImage.vue?vue&type=style&index=1&id=63d9297c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d9297c",
  null
  
)

export default component.exports